import {
    find as findDebtRequest,
} from 'src/repositories/debt.repository';

/**
 * Action Types
 */
export const DEBT_LOADING = 'DEBT_LOADING';
export const DEBT_LOADED = 'DEBT_LOADED';

/**
 * Action Creators
 */
export const loadingDebt = isLoading => ({
    type: DEBT_LOADING,
    payload: isLoading,
});

export const loadedDebt = debt => ({
    type: DEBT_LOADED,
    payload: debt,
});

/**
 * Actions
 */


export const loadDebt = id => (dispatch) => {
    dispatch(loadingDebt(true));
    return findDebtRequest(id)
        .then(({ data }) => {
            dispatch(loadedDebt(data));
        })
        .finally(() => {
            dispatch(loadingDebt(false));
        });
};
